// The PDF app's comments adapter. A comment anchors to the page being viewed
// (`page:<n>`) with the last text selected in the viewer as the quote;
// clicking a thread goes to that page.

import type { PdfViewerHandle } from "../PdfViewerHost";
import type { CommentAnchor, CommentsAdapter } from "./CommentsPanel";

const MAX_QUOTE = 500;
const ANCHOR_RE = /^page:(\d+)$/;

export function pdfCommentsAdapter(getViewer: () => PdfViewerHandle | null): CommentsAdapter {
    return {
        selectionHint: "Comments attach to the page you're on — select text on it to quote it.",

        captureAnchor: (): CommentAnchor | null => {
            const viewer = getViewer();
            const page = viewer?.currentPage() ?? 0;
            if (!viewer || page < 1) return null;
            const text = viewer.selectedText().replace(/\s+/g, " ").trim();
            return { anchor: `page:${page}`, quote: text ? text.slice(0, MAX_QUOTE) : null };
        },

        describeAnchor: (anchor) => {
            const m = ANCHOR_RE.exec(anchor);
            return m ? `Page ${m[1]}` : null;
        },

        navigate: (anchor) => {
            const m = anchor ? ANCHOR_RE.exec(anchor) : null;
            const viewer = getViewer();
            if (!m || !viewer) return false;
            return viewer.goToPage(Number(m[1]));
        }
    };
}
